export const isErrorResponse = response => typeof response === 'object' && response.isSuccess === false;
//# sourceMappingURL=index.js.map